<div class="return-product-dialog"
     [mmTestId]="'RETURN_PRODUCT_DIALOG.CONTAINER'">
    <mm-dialog-title>
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.TITLE' | translate }}&nbsp;{{data?.orderLine?.product?.name}}
    </mm-dialog-title>

    <section class="return-product-dialog__content">
        <div *ngIf="(returnReasonsLoading$ | async); else returnForm"
             class="return-product-dialog__spinner">
            <mm-spinner diameter="50"></mm-spinner>
        </div>
        <ng-template #returnForm>
            <div class="return-product-dialog__text">
                {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.TEXT' | translate }}
                <ng-container *ngIf="(showRefundFeeDisclaimer$ | async ) && data?.orderLine?.seller?.id === metroIdOrganization" >
                    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.REFUND_FEE_1' | translate }}
                    <a class="return-product-dialog__link" target="_blank" href="{{faqUrl}}">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.REFUND_FEE_2' | translate }}</a>
                </ng-container>
            </div>

            <form [formGroup]="form">
                <mm-field *ngIf="data?.orderLine?.quantity > 1">
                    <div fxLayout="row"
                         fxLayoutAlign="space-between flex-start">
                        <mm-label>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.QUANTITY' | translate }}</mm-label>
                        <mm-label>
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.QUANTITY_WERE' |
                          translate: { count: data?.orderLine?.quantity } }}
                        </mm-label>
                    </div>
                    <mm-quantity-picker class="return-product-dialog__q-picker"
                                        [mmTestTarget]="'quantity-picker'"
                                        [minAmount]="1"
                                        [amount]="data?.orderLine?.quantity"
                                        (quantityChanged)="onQuantityChanged($event)"
                                        [availableAmount]="data?.orderLine?.quantity"></mm-quantity-picker>
                </mm-field>

                <mm-field>
                    <mm-label>
                        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.REASON_LABEL' | translate }}</mm-label>
                    <mm-select [mmTestTarget]="'return-reasons-select'"
                               [options]="returnReasons$ | async"
                               [displayedProperty]="'title'"
                               [keyProperty]="'value'"
                               [placeholder]="'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCTS_DIALOG.SELECT_REASONS_PLACEHOLDER' | translate"
                               formControlName="returnReason"></mm-select>
                    <mm-error fieldName="returnReason">
                        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.REASON_ERROR' | translate }}</mm-error>
                </mm-field>
            </form>
        </ng-template>
    </section>

    <mm-dialog-footer>
        <button mm-button
                [color]="'ghost'"
                mmDialogClose
                [mmTestTarget]="'dialog-cancel-btn'">
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.CANCEL_BUTTON' | translate }}
        </button>

        <button mm-button
                [color]="'primary'"
                [mmTestTarget]="'dialog-submit-btn'"
                (click)="submit()">
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.CONFIRM_BUTTON' | translate }}
        </button>
    </mm-dialog-footer>
</div>
